"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trans2ExcelData = trans2ExcelData;
exports.transCell2Data = transCell2Data;
exports.getExcelColumnsByFormItems = getExcelColumnsByFormItems;
exports.getExcelDataByFormItems = getExcelDataByFormItems;
exports.addSelect2WorkSheet = addSelect2WorkSheet;
exports.addNumberFormat = addNumberFormat;
exports.addColumnRequiredColor = addColumnRequiredColor;
exports.mergeSheetCells = mergeSheetCells;
exports.addSheetBorder = addSheetBorder;
exports.transSheetByFormItemsAndData = transSheetByFormItemsAndData;
exports.writeFile = writeFile;
exports.exportXlsx = exportXlsx;
exports.transWorkSheet2List = transWorkSheet2List;
exports.transDataWithSearchLabelValue = transDataWithSearchLabelValue;
exports.importXlsx = importXlsx;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _vueJsonView = require("vue-json-view");

var _exceljs = _interopRequireWildcard(require("exceljs"));

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _lodash = _interopRequireDefault(require("lodash"));

var _fieldType = require("../fieldType");

var _linkApi = require("./linkApi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trans2ExcelData(data, allData) {
  if (typeof data === 'string') {
    return _vueJsonView.Utils.transText(data, allData);
  } else if ((0, _typeof2.default)(data) !== 'object') {
    return data;
  } else if (Array.isArray(data)) {
    data = data.filter(function (c) {
      return (0, _typeof2.default)(c) !== 'object';
    });
    return data.join(' ');
  } else {
    return '';
  }
}

function transCell2Data(cell) {
  var _result$richText, _result$richText$;

  var value = cell.value,
      type = cell.type;
  var result;

  switch (type) {
    case _exceljs.ValueType.Hyperlink:
      result = value === null || value === void 0 ? void 0 : value.text;

      if ((0, _typeof2.default)(result) === 'object' && (_result$richText = result.richText) !== null && _result$richText !== void 0 && (_result$richText$ = _result$richText[0]) !== null && _result$richText$ !== void 0 && _result$richText$.text) {
        var _result$richText2, _result$richText2$;

        result = (_result$richText2 = result.richText) === null || _result$richText2 === void 0 ? void 0 : (_result$richText2$ = _result$richText2[0]) === null || _result$richText2$ === void 0 ? void 0 : _result$richText2$.text;
      }

      break;

    case _exceljs.ValueType.Formula:
      result = value === null || value === void 0 ? void 0 : value.result;

      if (typeof result === 'number') {
        // fix: js 浮点数计算失精问题
        result = Number(result.toFixed(12));
      }

      break;

    case _exceljs.ValueType.Number:
      result = Number(value === null || value === void 0 ? void 0 : value.toFixed(12));
      break;

    case _exceljs.ValueType.RichText:
      result = value === null || value === void 0 ? void 0 : value.richText;
      break;

    case _exceljs.ValueType.SharedString:
      result = value === null || value === void 0 ? void 0 : value.result;
      break;

    default:
      result = value;
      break;
  }

  return result;
}

function getExcelColumnsByFormItems(columns) {
  var excelColumns = [];
  columns.forEach(function (col) {
    if (col.children) {
      var _col$children;

      // 子表单
      (_col$children = col.children) === null || _col$children === void 0 ? void 0 : _col$children.forEach(function (c) {
        excelColumns.push({
          header: c.title,
          key: c.dataIndex
        });
      });
    } else {
      excelColumns.push({
        header: col.title,
        key: col.dataIndex
      });
    }
  });
  return excelColumns;
}

function getExcelDataByFormItems(columns, dataSource) {
  return dataSource.map(function (record) {
    var line = [];
    columns.map(function (col) {
      var currentData = _vueJsonView.Utils.getDataByName(record, col.dataIndex || col.key);

      if (col.children) {
        // 子表单
        col.children.map(function (c) {
          var cd = _vueJsonView.Utils.getDataByName(record, c.dataIndex || c.key);

          if (c.customRender) {
            cd = c.customRender(cd, currentData);
          }

          line.push(trans2ExcelData(cd, currentData));
        });
      } else {
        var interRecord = record;

        if (col.objectArrayName) {
          interRecord = _vueJsonView.Utils.getDataByName(record, col.objectArrayName + '.' + ((record === null || record === void 0 ? void 0 : record._objectArrayIndex) || 0));
        }

        if (col.customRender) {
          currentData = col.customRender(currentData, record);
        }

        line.push(trans2ExcelData(currentData, interRecord));
      }
    });
    return line;
  });
}

function addSelect2WorkSheet(workSheet, formItems) {
  formItems.forEach(function (item) {
    var _item$_type;

    if (((_item$_type = item._type) === null || _item$_type === void 0 ? void 0 : _item$_type.type) === 'labelValue') {
      var _item$_type2, _item$_type3, _Utils$getDataByName;

      if (!item._type.path) {
        return;
      }

      var labelName = (_item$_type2 = item._type) !== null && _item$_type2 !== void 0 && _item$_type2.labelPath ? _vueJsonView.Utils.getDataByName(item, (_item$_type3 = item._type) === null || _item$_type3 === void 0 ? void 0 : _item$_type3.labelPath) : 'label';
      var options = ((_Utils$getDataByName = _vueJsonView.Utils.getDataByName(item, item._type.path)) === null || _Utils$getDataByName === void 0 ? void 0 : _Utils$getDataByName.map(function (l) {
        return (0, _typeof2.default)(l) === 'object' ? l[labelName] : l;
      })) || [];
      var formulae = '"' + options.join(',') + '"';
      var col = workSheet.getColumn(item.name);

      if (formulae.length > 255) {
        return;
      }

      var dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [formulae]
      };

      if (workSheet.rowCount === 1) {
        workSheet.getCell(2, col === null || col === void 0 ? void 0 : col.number).dataValidation = dataValidation;
      } else {
        var _col$eachCell;

        col === null || col === void 0 ? void 0 : (_col$eachCell = col.eachCell) === null || _col$eachCell === void 0 ? void 0 : _col$eachCell.call(col, {
          includeEmpty: true
        }, function (cell, i) {
          if (i === 1) {
            return;
          }

          cell.dataValidation = dataValidation;
        });
      }
    }
  });
}

function addNumberFormat(worksheet, formItems) {
  formItems.forEach(function (item) {
    if (item._type === 'number') {
      var col = worksheet.getColumn(item.name);

      if (worksheet.rowCount === 1) {
        worksheet.getCell(2, col === null || col === void 0 ? void 0 : col.number).numFmt = '#,##0.00 ;(#,##0.00)';
      } else {
        var _col$eachCell2;

        col === null || col === void 0 ? void 0 : (_col$eachCell2 = col.eachCell) === null || _col$eachCell2 === void 0 ? void 0 : _col$eachCell2.call(col, {
          includeEmpty: true
        }, function (cell, i) {
          if (i === 1) {
            return;
          }

          cell.numFmt = '#,##0.00 ;(#,##0.00)';

          if (cell.value) {
            cell.value = Number(cell.value);
          }
        });
      }
    }
  });
}

function addColumnRequiredColor(workSheet, formItems) {
  var preName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  formItems.forEach(function (item) {
    var _item$_type4;

    if ((item === null || item === void 0 ? void 0 : (_item$_type4 = item._type) === null || _item$_type4 === void 0 ? void 0 : _item$_type4.type) === 'objectArray') {
      var _item$_type5;

      // 子表单情况
      var children = _vueJsonView.Utils.getDataByName(item, (_item$_type5 = item._type) === null || _item$_type5 === void 0 ? void 0 : _item$_type5.path);

      addColumnRequiredColor(workSheet, children, preName + item.name + '__');
    } else if (item.required) {
      var cell = workSheet.getRow(1).getCell(preName + item.name);
      cell.font = {
        color: {
          argb: 'fff20000'
        }
      };
    }
  });
}

function mergeSheetCells(workSheet, columns, dataSource) {
  dataSource.forEach(function (data, i) {
    columns.forEach(function (col) {
      var rowSpan = data[(col.dataIndex || col.key) + '_rowSpan'] || data.rowSpan || 0;

      if (rowSpan > 1) {
        var colIndex = workSheet.getColumn(col.dataIndex).number;

        if (colIndex) {
          // 合并单元格
          workSheet.mergeCells(i + 2, colIndex, i + rowSpan + 1, colIndex); // 设置垂直居中

          workSheet.getCell(i + rowSpan + 1, colIndex).alignment = {
            vertical: 'middle'
          };
        }
      }
    });
  });
}

function addSheetBorder(worksheet) {
  worksheet.eachRow(function (row) {
    Array.from({
      length: worksheet.columns.length
    }).forEach(function (l, i) {
      row.getCell(i + 1).border = {
        top: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
        left: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
        bottom: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        },
        right: {
          style: 'thin',
          color: {
            argb: 'FF000000'
          }
        }
      };
    });
  });
}

function transSheetByFormItemsAndData(workSheet, formItems, dataSource) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    showSelect: true,
    showRequired: false,
    border: true
  };
  formItems = formItems.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item._type) !== 'jsonView';
  });

  var tableColumns = _fieldType.FieldType.trans2TreeByType(formItems); // 插入表头


  workSheet.columns = getExcelColumnsByFormItems(tableColumns); // 插入数据

  workSheet.addRows(getExcelDataByFormItems(tableColumns, dataSource)); // 合并单元格

  mergeSheetCells(workSheet, tableColumns, dataSource); // 添加下拉框

  if (options !== null && options !== void 0 && options.showSelect) {
    addSelect2WorkSheet(workSheet, formItems);
  }

  addNumberFormat(workSheet, formItems); // 必填加红

  if (options !== null && options !== void 0 && options.showRequired) {
    addColumnRequiredColor(workSheet, formItems);
  } // 加边框


  if (options !== null && options !== void 0 && options.border) {
    addSheetBorder(workSheet);
  }
}

function writeFile(_x, _x2) {
  return _writeFile.apply(this, arguments);
}

function _writeFile() {
  _writeFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(workbook, fileName) {
    var buffer, blob;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return workbook.xlsx.writeBuffer();

          case 2:
            buffer = _context.sent;
            blob = new Blob([buffer]);

            _fileSaver.default.saveAs(blob, fileName);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _writeFile.apply(this, arguments);
}

function exportXlsx(_x3, _x4, _x5) {
  return _exportXlsx.apply(this, arguments);
}

function _exportXlsx() {
  _exportXlsx = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(formItems, dataSource, options) {
    var workbook, sheet;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            workbook = new _exceljs.default.Workbook();
            sheet = workbook.addWorksheet('sheet1');
            transSheetByFormItemsAndData(sheet, formItems, dataSource, options);
            writeFile(workbook, options.fileName);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _exportXlsx.apply(this, arguments);
}

function transFile2Buffer(file) {
  return new Promise(function (resolve) {
    var reader = new FileReader();

    reader.onload = function (e) {
      var binary = '';
      var bytes = new Uint8Array(e.target.result);

      for (var i = 0; i < bytes.length; ++i) {
        binary += String.fromCharCode(bytes[i]);
      }

      resolve(binary);
    };

    reader.readAsArrayBuffer(file);
  });
}

function transWorkSheet2List(workSheet, formItems) {
  var result = [];

  var tableColumns = _fieldType.FieldType.trans2TreeByType(formItems);

  var sortedTableColumns = [];
  var objectArrayKeys = []; // 对每一列进行排序

  workSheet.getRow(1).eachCell(function (cell) {
    sortedTableColumns.push(tableColumns.find(function (col) {
      return col.title === cell.value;
    }));
  }); // 寻找子表单的 key

  formItems.forEach(function (item) {
    var _item$_type6;

    if (((_item$_type6 = item._type) === null || _item$_type6 === void 0 ? void 0 : _item$_type6.type) === 'objectArray') {
      objectArrayKeys.push(item.name);
    }
  });
  workSheet.eachRow(function (row, i) {
    if (i === 1) {
      return;
    }

    var record = {};
    var objectArrayFlag = false;
    sortedTableColumns.forEach(function (col, j) {
      if (!col) {
        return;
      }

      var cell = row.getCell(j + 1);
      var currentData = transCell2Data(cell);

      if (col.reverseRender) {
        currentData = col.reverseRender(currentData);
      }

      var s = i - 1;

      while (s > 1) {
        if (cell.isMergedTo(workSheet.getCell(s, j + 1))) {
          // 是合并单元格
          objectArrayFlag = true;
          break;
        }

        s--;
      }

      var key = col.dataIndex || col.key || '';

      _lodash.default.set(record, key, currentData);
    }); // 把子表单属性提出来

    Object.keys(record).forEach(function (key) {
      objectArrayKeys.forEach(function (matchKey) {
        if (!key.startsWith(matchKey + '__')) {
          return;
        }

        if (!record[matchKey]) {
          record[matchKey] = [{}];
        }

        var shortName = key.substring(matchKey.length + 2);
        record[matchKey][0][shortName] = record[key];
        delete record[key];
      });
    }); // 如果不是合并单元格的第一行

    if (objectArrayFlag) {
      var lastRecord = result[result.length - 1];
      objectArrayKeys.forEach(function (matchKey) {
        if (!record[matchKey]) {
          return;
        }

        if (!lastRecord[matchKey]) {
          lastRecord[matchKey] = [];
        }

        lastRecord[matchKey].push(record[matchKey][0]);
      });
    } else {
      result.push(record);
    }
  });
  return result;
}

function transDataWithSearchLabelValue(_x6, _x7) {
  return _transDataWithSearchLabelValue.apply(this, arguments);
}

function _transDataWithSearchLabelValue() {
  _transDataWithSearchLabelValue = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(list, formItems) {
    var searchLabelValueColumns, result, _loop, i;

    return _regenerator.default.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            searchLabelValueColumns = formItems.filter(function (item) {
              var _item$_type7, _item$_type8, _item$_type8$items;

              if (item._type === 'searchLabelValue' || ((_item$_type7 = item._type) === null || _item$_type7 === void 0 ? void 0 : _item$_type7.type) === 'searchLabelValue' || ((_item$_type8 = item._type) === null || _item$_type8 === void 0 ? void 0 : (_item$_type8$items = _item$_type8.items) === null || _item$_type8$items === void 0 ? void 0 : _item$_type8$items.type) === 'searchLabelValue') {
                var _item$link, _item$link2;

                return ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.formId) && ((_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.searchFields);
              }
            });

            if (searchLabelValueColumns.length) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", list);

          case 3:
            result = list.slice();
            _loop = /*#__PURE__*/_regenerator.default.mark(function _loop(i) {
              var col, link, dataList, matchFieldList;
              return _regenerator.default.wrap(function _loop$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      col = searchLabelValueColumns[i];
                      link = col.link;
                      _context3.next = 4;
                      return (0, _linkApi.getServerList)(link.formId);

                    case 4:
                      dataList = _context3.sent;
                      matchFieldList = dataList === null || dataList === void 0 ? void 0 : dataList.map(function (item) {
                        var _link$searchFields;

                        return _objectSpread(_objectSpread({}, item), {}, {
                          _matches: (_link$searchFields = link.searchFields) === null || _link$searchFields === void 0 ? void 0 : _link$searchFields.map(function (field) {
                            return _vueJsonView.Utils.getDataByName(item, field);
                          })
                        });
                      });
                      result = result.map(function (item) {
                        var newItem = _lodash.default.cloneDeep(item);

                        var currentValue = _vueJsonView.Utils.getDataByName(item, col.name);

                        _lodash.default.set(newItem, col.name, undefined);

                        if (!currentValue) {
                          return newItem;
                        }

                        var matchObj = matchFieldList === null || matchFieldList === void 0 ? void 0 : matchFieldList.find(function (field) {
                          var _field$_matches;

                          return field === null || field === void 0 ? void 0 : (_field$_matches = field._matches) === null || _field$_matches === void 0 ? void 0 : _field$_matches.some(function (match) {
                            return match && (match + '').trim() === (currentValue + '').trim();
                          });
                        });

                        if (matchObj) {
                          var _link$showFields;

                          _lodash.default.set(newItem, col.name, {
                            label: (_link$showFields = link.showFields) === null || _link$showFields === void 0 ? void 0 : _link$showFields.map(function (item) {
                              return _vueJsonView.Utils.getDataByName(matchObj, item.name);
                            }).join('/'),
                            value: matchObj._id
                          });
                        }

                        return newItem;
                      });

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _loop);
            });
            i = 0;

          case 6:
            if (!(i < searchLabelValueColumns.length)) {
              _context4.next = 11;
              break;
            }

            return _context4.delegateYield(_loop(i), "t0", 8);

          case 8:
            ++i;
            _context4.next = 6;
            break;

          case 11:
            return _context4.abrupt("return", result);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _transDataWithSearchLabelValue.apply(this, arguments);
}

function importXlsx(_x8, _x9, _x10) {
  return _importXlsx.apply(this, arguments);
}

function _importXlsx() {
  _importXlsx = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(file, formItems, sheetName) {
    var workBook, buffer, workSheet, list;
    return _regenerator.default.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            workBook = new _exceljs.default.Workbook();
            _context5.next = 3;
            return transFile2Buffer(file);

          case 3:
            buffer = _context5.sent;
            _context5.next = 6;
            return workBook.xlsx.load(buffer);

          case 6:
            workSheet = sheetName ? workBook.getWorksheet(sheetName) : workBook.worksheets.filter(function (f) {
              return f;
            })[0];

            if (!workSheet) {
              _context5.next = 12;
              break;
            }

            list = transWorkSheet2List(workSheet, formItems);
            _context5.next = 11;
            return transDataWithSearchLabelValue(list, formItems);

          case 11:
            return _context5.abrupt("return", _context5.sent);

          case 12:
            return _context5.abrupt("return", []);

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _importXlsx.apply(this, arguments);
}